import {
  useGetBatchHistory,
  useGetManagementBatchHistory,
} from "../../../hooks/queries/useBulkUploadsQueries";

export const useBatchHistory = (apiFilters, managementApiFilters, isSuperAdmin = false) => {
  const merchantQuery = useGetBatchHistory(apiFilters, { enabled: !isSuperAdmin });
  const managementQuery = useGetManagementBatchHistory(managementApiFilters, { enabled: isSuperAdmin });

  const { data, isLoading, isFetching, isError, refetch } = isSuperAdmin ? managementQuery : merchantQuery;

  return {
    content: data?.content ?? [],
    totalPages: data?.totalPages ?? 0,
    totalElements: data?.totalElements ?? 0,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};

export default useBatchHistory;
